"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _labelConsts = require("../../constants/labelConsts");
var _HintMark = _interopRequireDefault(require("./HintMark"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const LabelContainer = (0, _styles.styled)(_Grid.default)({
  minHeight: '32px'
});
const LabelName = (0, _styles.styled)(_Typography.default)({
  fontWeight: 700,
  color: '#333333',
  margin: 'auto 2px',
  height: '1em',
  display: 'inline'
});
const Required = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    fontSize: theme.typography.fontSize * 0.886,
    textAlign: 'center',
    display: 'inline-block',
    backgroundColor: theme.palette.required.main,
    color: theme.palette.required.contrastText,
    padding: theme.spacing(0.25),
    margin: 'auto 2px'
  };
});
const ChildWrapper = (0, _styles.styled)(_Grid.default, {
  shouldForwardProp: prop => prop !== '$indent'
})(_ref2 => {
  let {
    theme,
    $indent
  } = _ref2;
  return _objectSpread({}, !!$indent && {
    paddingLeft: theme.spacing(2)
  });
});

/**
 * @classdesc ラベルと一緒に表示する部品.
 * @prop {string} label - ラベルに表示する文字列
 * @prop {bool} [required=false] - 必須ラベルを表示する場合true
 * @prop {string} [hint] - ヒントコンテンツのid。
 * @prop {bool} [indent] - インデントをつける場合true
 */
class CLabel extends _react.default.Component {
  render() {
    const {
      intl,
      label,
      required,
      hint,
      children,
      className,
      indent
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(LabelContainer, {
      container: true,
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(LabelName, {
      variant: "subtitle2",
      className: className
    }, label)), required && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(Required, {
      component: "div"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_REQUIRED
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, hint && /*#__PURE__*/_react.default.createElement(_HintMark.default, {
      hint: hint
    })))), children && /*#__PURE__*/_react.default.createElement(ChildWrapper, {
      size: {
        xs: 12
      },
      $indent: indent
    }, children));
  }
}
CLabel.propTypes = {
  label: _propTypes.default.string.isRequired,
  required: _propTypes.default.bool,
  hint: _propTypes.default.string,
  indent: _propTypes.default.bool
};
var _default = exports.default = (0, _reactIntl.injectIntl)(CLabel);